import React from 'react';

import { Box, Typography } from '@mui/material';
import { ConfirmIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { EMPTY_DOCUMENTS } from '../../MilestoneRoadmapWidget.constants';
import {
  MILESTONE_ROADMAP_STATUS,
  ROADMAP_CURRENT_ROW_SCROLL_ID,
  ROADMAP_EMPTY_DATE,
  ROADMAP_HERE_TEXT,
} from '../MilestoneRoadmap/MilestoneRoadmap.constants';
import { getInProgressLabel } from '../MilestoneRoadmap/MilestoneRoadmap.utils';
import MilestoneRoadmapDocuments from '../MilestoneRoadmapDocuments';

import {
  getCoreStyles,
  getDateStyles,
  getHereStyles,
  getHollowStyles,
  getNameStyles,
  getNodeStyles,
  getRowStyles,
  metaStyles,
  midStyles,
  rightStyles,
} from './MilestoneRoadmapItem.styles';

const getMetaText = ({ status, durationLabel, daysOnCurrent }) =>
  status === MILESTONE_ROADMAP_STATUS.CURRENT ? getInProgressLabel(daysOnCurrent) : durationLabel;

const MilestoneRoadmapItem = ({
  name,
  status,
  colors,
  date = null,
  durationLabel = null,
  daysOnCurrent = null,
  documents = EMPTY_DOCUMENTS,
}) => {
  const { strong } = colors;
  const isCompleted = status === MILESTONE_ROADMAP_STATUS.COMPLETED;
  const isCurrent = status === MILESTONE_ROADMAP_STATUS.CURRENT;
  const metaText = getMetaText({ status, durationLabel, daysOnCurrent });
  const isDocumentsRendered = (isCurrent || isCompleted) && documents.length > 0;

  return (
    <Box
      data-scrollid={isCurrent ? ROADMAP_CURRENT_ROW_SCROLL_ID : null}
      sx={getRowStyles(status, colors)}
    >
      <Box sx={getNodeStyles(status, colors)}>
        {isCompleted && <ConfirmIcon size={12} />}
        {isCurrent && <Box sx={getCoreStyles(strong)} />}
        {status === MILESTONE_ROADMAP_STATUS.UPCOMING && <Box sx={getHollowStyles(colors)} />}
      </Box>

      <Box sx={midStyles}>
        <Typography
          sx={getNameStyles(status, colors)}
          variant={isCurrent || isCompleted ? 'medium14' : 'regular14'}
        >
          {name}
        </Typography>
        {metaText && (
          <Typography sx={metaStyles} variant="regular12">
            {metaText}
          </Typography>
        )}
        {isDocumentsRendered && (
          <MilestoneRoadmapDocuments documents={documents} isExpandedByDefault={isCurrent} />
        )}
      </Box>

      <Box sx={rightStyles}>
        <Typography sx={getDateStyles(status)} variant="regular12">
          {date ?? ROADMAP_EMPTY_DATE}
        </Typography>
        {isCurrent && (
          <Typography sx={getHereStyles(colors)} variant="bold12">
            {ROADMAP_HERE_TEXT}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

MilestoneRoadmapItem.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.oneOf(Object.values(MILESTONE_ROADMAP_STATUS)).isRequired,
  colors: PropTypes.shape({
    strong: PropTypes.string.isRequired,
    soft: PropTypes.string.isRequired,
    deep: PropTypes.string.isRequired,
  }).isRequired,
  date: PropTypes.string,
  durationLabel: PropTypes.string,
  daysOnCurrent: PropTypes.number,
  documents: PropTypes.array,
};

export default MilestoneRoadmapItem;
